import type { GridRowId } from '@mui/x-data-grid';

import type { SelectionRestriction } from '../types/selection-restriction.type';

export const isSelectableIn = (
  restriction: SelectionRestriction | undefined,
  id: GridRowId,
): boolean =>
  !restriction ||
  restriction.selectableIds.some((selectableId) => selectableId === id);
